import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DistribuidorDeContenidosService } from '../servicio/distribuidor-de-contenidos.service';


@Component({
  selector: 'app-ayuda',
  templateUrl: './ayuda.component.html',
  styleUrls: ['./ayuda.component.css']
})
export class AyudaComponent implements OnInit {
  titulo: string;
  descripcion: string;
  datosAyuda: { imagen: string; }[];
  referModal: BsModalRef;
  subtituloA: string
  subtituloB: string
  textosAyuda: { texto: string; }[];

  constructor(private servicioModal: BsModalService, private distribuidor: DistribuidorDeContenidosService) {
    this.titulo = distribuidor.contenidoAyuda.titulo
    this.descripcion = distribuidor.contenidoAyuda.descripcion
    this.datosAyuda = distribuidor.contenidoAyuda.datosAyuda
    this.subtituloA = distribuidor.contenidoAyuda.subtituloA
    this.subtituloB = distribuidor.contenidoAyuda.subtituloB
    this.textosAyuda = distribuidor.contenidoAyuda.textosAyuda
  }

  ngOnInit(): void {
  }

  abrirModal(plantilla: TemplateRef<any>) {
    this.referModal = this.servicioModal.show(plantilla);
  }

  enlace() {
    window.open("https://donaronline.org/asoc-civil-jesus-amigo/tu-ayuda-puede-cambiar-vidas", "_blank");
  }

}
